import { paperClasses } from '@mui/material';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const StyledPaper = styled(Stack)(({ theme }) => ({
  backgroundColor: 'transparent',
  marginBottom: theme.spacing(1),
  opacity: 1,
  transition: theme.transitions.create(['opacity', 'background-color']),
}));

export const StyledPopover = styled(Popover)(() => ({
  [`& .${paperClasses.root}`]: {
    width: '100%',
    maxWidth: 400,
    maxHeight: '80vh',
  },
}));

export const LoaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(3),
}));

export const StyledTitleStack = styled(Stack)(({ theme }) => ({
  flexGrow: 0,
  flexShrink: 0,
  padding: theme.spacing(3, 5),
}));

export const StyledNotificationsStack = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  overflowY: 'auto',
  height: '100%',
  padding: theme.spacing(1, 5, 5, 5),
}));
